{
  "priceList": {
    "title": "Koble på prisliste i Virkeshandel",
    "description": "Velg hvilken prisliste i VH du ønsker å koble salgsavtalen mot",
    "year": {
      "label": "År",
      "placeholder": ""
    },
    "agreementType": {
      "label": "Avtaletype",
      "placeholder": "",
      "options": {
        "withForestOwnerAgreement": "Har skogeieravtale",
        "withoutForestOwnerAgreement": "Har ikke skogeieravtale"
      }
    },
    "deliveryType": {
      "label": "Leveransetype",
      "placeholder": "",
      "options": {
        "resale": "Videresalg",
        "timberSale": "Tømmersalg"
      }
    },
    "currency": {
      "label": "Valuta",
      "placeholder": "NOK"
    },
    "priceList": {
      "label": "Prisliste i VH",
      "placeholder": "",
      "searchPlaceholder": "Søk etter prisliste",
      "noResultsText": "Ingen prislister funnet"
    }
  }
}
